"use client";

import { UploadFile } from "@/types/generated";
import React from "react";
import { generateLinkFromGeneralLink, LinkConfig } from "@/lib/utils";
import { RichtextRenderer } from "@/components/atoms/rich-text-render";import Image from "next/image";
interface IBannerSectionProps {
  locale: string;
  desktopImage: UploadFile;
  mobileImage: UploadFile;
  onsenPageLink: LinkConfig;
  freeText: string;
}
/**
 * OnsenBannerSection
 *
 * Displays a responsive banner section for the Onsen (hot spring) page.
 * It supports both desktop and mobile banner images, a free text area,
 * and redirects to an external/internal page when clicked.
 */
const OnsenBannerSection: React.FC<IBannerSectionProps> = ({
  locale,
  desktopImage,
  mobileImage,
  onsenPageLink,
  freeText,
}) => {
  /** Generate the localized link using utility helper */
  const link = generateLinkFromGeneralLink(onsenPageLink, locale);

  /**
   * Handle banner click redirection.
   * Opens the link in the target specified in the metadata
   * (defaults to current tab if target not provided).
   */
  const onRedirect = () => {
    window.open(link, onsenPageLink?.metadata?.target || "_parent");
  };
  return (
    <div className="w-full md:mb-5">
      <RichtextRenderer content={freeText} />
      {/**
       * Responsive banner section:
       * - Clickable container that redirects on click.
       * - Shows different images for desktop and mobile.
       */}
      <button
        onClick={onRedirect}
        className="relative flex w-full cursor-pointer flex-col items-center"
      >
        <Image
          className="relative hidden object-cover object-center md:block"
          src={desktopImage?.cloudflare_url || desktopImage?.url}
          alt={desktopImage.alternativeText || ""}
          aria-label={desktopImage.caption || ""}
          fill
        />
        <Image
          className="relative h-auto w-full md:hidden"
          src={mobileImage?.cloudflare_url || mobileImage?.url}
          alt={mobileImage.alternativeText || ""}
          aria-label={mobileImage.caption || ""}
          fill
        />
      </button>
    </div>
  );
};

export { OnsenBannerSection };
